// Unpublished Work © 2026 Deere & Company.

import React, {useEffect} from 'react';
import {getRedirectUrl} from '../services/redirect-service';

export const RedirectPage = () => {
    useEffect(() => {
        const fetchData = async () => {
            await getRedirectUrl();
        };
        fetchData();
    }, []);

    return <div />;
};
